import { customAlphabet } from 'nanoid';

const defaultAlphabet = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz_';

export default (length = 12, alphabet) => customAlphabet(alphabet || defaultAlphabet)(length);
